import classNames from 'classnames';
import { BaseTextFieldProps, InputField } from './InputField';

export const TextField = ({ maxLength, placeholder, formControlClassName, autoTrim = false, ...props }: BaseTextFieldProps) => {
    return (
        <InputField {...props} renderElement={(formik, field, meta, helpers) => {
            const withError = meta.touched && meta.error;
            return (
                <div className="data-item-col">
                    <input
                        className={classNames('form-control', formControlClassName, { 'is-invalid': withError })}
                        {...field}
                        maxLength={maxLength}
                        value={field.value || ''}
                        onBlur={e => {
                            field.onBlur(e);
                            if (autoTrim && typeof field.value === 'string' && field.value !== field.value.trim()) {
                                helpers.setValue(field.value.trim());
                            }
                        }}
                        placeholder={placeholder}
                    />
                    {withError && <div className="form-error">{meta.error}</div>}
                </div>
            )
        }} />
    );
}
